import { render } from "./ReturnsEstimator.vue?vue&type=template&id=98ba1712&scoped=true"
import script from "./ReturnsEstimator.vue?vue&type=script&lang=js"
export * from "./ReturnsEstimator.vue?vue&type=script&lang=js"

import "./ReturnsEstimator.vue?vue&type=style&index=0&id=98ba1712&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98ba1712"]])

export default __exports__